import React, { useState, useEffect } from 'react';
import DataTable from '../components/DataTable';
import FormModal from '../components/FormModal';
import { catalogosAPI } from '../services/api';
import '../styles/Pages.css';

function Catalogos() {
  const [catalogos, setCatalogos] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCatalogo, setSelectedCatalogo] = useState(null);
  const [loading, setLoading] = useState(true);

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'nombre', label: 'Nombre' },
    { key: 'tipo', label: 'Tipo' },
    { key: 'descripcion', label: 'Descripción' },
    { key: 'activo', label: 'Activo' }
  ];

  const formFields = [
    { name: 'nombre', label: 'Nombre', type: 'text', required: true, placeholder: 'Ej: Autos' },
    { name: 'tipo', label: 'Tipo', type: 'text', required: true, placeholder: 'Ej: Categoría' },
    { name: 'descripcion', label: 'Descripción', type: 'textarea', required: false, placeholder: 'Descripción detallada...' },
    { name: 'activo', label: 'Activo', type: 'text', required: false, placeholder: 'Sí/No' }
  ];

  useEffect(() => {
    fetchCatalogos();
  }, []);

  const fetchCatalogos = async () => {
    try {
      setLoading(true);
      const response = await catalogosAPI.getAll();
      setCatalogos(response.data);
    } catch (error) {
      console.error('Error fetching catalogos:', error);
      setCatalogos([
        { id: 1, nombre: 'Autos', tipo: 'Categoría', descripcion: 'Créditos para automóviles', activo: 'Sí' },
        { id: 2, nombre: 'Negocios', tipo: 'Categoría', descripcion: 'Créditos para emprendimientos', activo: 'Sí' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleAddCatalogo = () => {
    setSelectedCatalogo(null);
    setIsModalOpen(true);
  };

  const handleEditCatalogo = (catalogo) => {
    setSelectedCatalogo(catalogo);
    setIsModalOpen(true);
  };

  const handleSaveCatalogo = async (formData) => {
    try {
      if (selectedCatalogo) {
        await catalogosAPI.update(selectedCatalogo.id, formData);
      } else {
        await catalogosAPI.create(formData);
      }
      setIsModalOpen(false);
      fetchCatalogos();
    } catch (error) {
      console.error('Error saving catalogo:', error);
      if (selectedCatalogo) {
        setCatalogos(catalogos.map(c => c.id === selectedCatalogo.id ? { ...c, ...formData } : c));
      } else {
        setCatalogos([...catalogos, { id: Math.max(...catalogos.map(c => c.id), 0) + 1, ...formData }]);
      }
      setIsModalOpen(false);
    }
  };

  const handleDeleteCatalogo = async (id) => {
    if (window.confirm('¿Deseas eliminar este catálogo?')) {
      try {
        await catalogosAPI.delete(id);
        fetchCatalogos();
      } catch (error) {
        console.error('Error deleting catalogo:', error);
        setCatalogos(catalogos.filter(c => c.id !== id));
      }
    }
  };

  return (
    <div className="page-container">
      {loading ? (
        <div className="loading">Cargando...</div>
      ) : (
        <>
          <DataTable
            columns={columns}
            data={catalogos}
            onAdd={handleAddCatalogo}
            onEdit={handleEditCatalogo}
            onDelete={handleDeleteCatalogo}
            addLabel="Nuevo catálogo"
          />

          <FormModal
            isOpen={isModalOpen}
            title={selectedCatalogo ? 'Editar Catálogo' : 'Nuevo Catálogo'}
            fields={formFields}
            data={selectedCatalogo}
            onSave={handleSaveCatalogo}
            onClose={() => setIsModalOpen(false)}
          />
        </>
      )}
    </div>
  );
}

export default Catalogos;
